import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { BDataGrid } from '../common/dataGrid/BDataGrid';
import BrowserUtils from '../../utils/BrowserUtils';
import NumberUtils from '../../utils/NumberUtils';
import { CreateBudgetTableRowTemplate } from './CreateBudgetTableRowTemplate';
import { CreateBudgetTableRowTemplateMobile } from './CreateBudgetTableRowTemplate_Mobile';
import { OverlayPopup } from '../common/modals/OverlayPopup';

const columnMeta = [
  {
    columnName: 'name',
    order: 1,
    locked: false,
    visible: true,
    displayName: 'Tag',
    sortable: true,
    sortDirectionCycle: ['desc', 'asc'],
    customComponent: CreateBudgetTableRowTemplate,
    freeze: 'Pots',
    cssClassName: 'column-tag',
  },
  {
    columnName: 'last_month',
    order: 2,
    locked: false,
    visible: true,
    displayName: 'Last Month',
    sortable: true,
    sortDirectionCycle: ['desc', 'asc'],
    customComponent: CreateBudgetTableRowTemplate,
    cssClassName: 'column-last-month',
  },
  {
    columnName: 'target_amount',
    order: 3,
    locked: false,
    visible: true,
    displayName: 'Budget',
    sortable: true,
    customComponent: CreateBudgetTableRowTemplate,
    sortDirectionCycle: ['desc', 'asc'],
    cssClassName: 'column-budget',
  },
];

/**
 * @todo
 * It maybe impossible to improvethe quality of this component even further.
 */
class SpendingsCreateBudgetDataGrid extends Component {
  constructor(props) {
    super(props);

    this.sortTableData = this.sortTableData.bind(this);

    this.state = {
      tableData: props.tableData,
    };
  }

  sortTableData(sortby, sortAscDesc) {
    /**
     * @todo Refactor: No need to use let and assign to null.
     * Can be made declerative using:
     * ```js
     * const sortedTableData = sortby === 'last_month' ? (work) : (elseFallback);
     * ```
     * *KW – 8/3/2022*
     */
    let sortedTableData = null;
    if (sortby === 'last_month') {
      sortedTableData = _.sortBy(this.state.tableData, [
        'last_month',
        'target_amount',
        'name',
      ]);
    } else {
      sortedTableData = _.sortBy(this.state.tableData, [sortby]);
    }

    if (sortAscDesc === 'desc') {
      sortedTableData.reverse();
    }

    this.setState({
      tableData: sortedTableData,
    });
  }

  render() {
    const tableData = this.state.tableData;
    let transactionDataGridDesktopScreen;
    let transactionScreenMobileRows;
    let potDataRow;
    let potData;
    let differencePot;
    let potColor = 'potcolor green';
    /**
     * @todo Refactor:
     * You'll see here that based on isMobileView we assign JSX to a variable.
     * When we eventually return JSX to render at the end of the function, we
     * do the same check again. The flow of the render function could be refactored
     * to ensure we only do this once, and avoid assignement of JSX to a variable.
     *
     * *KW – 8/3/2022*
     */
    if (!BrowserUtils.isMobileView()) {
      transactionDataGridDesktopScreen = (
        <div className="spendings-grid oldTable">
          <BDataGrid
            results={tableData}
            columns={['name', 'last_month', 'target_amount']}
            columnMetadata={columnMeta}
            initialSortAscending={false}
            customClick={this.props.customClick}
            initialSort="last_month"
            onSort={this.sortTableData}
            enableInfiniteScroll={false}
            useFixedHeader
            showPager={false}
            useCustomPagerComponent="false"
            resultsPerPage={tableData.length}
            bodyHeight={400}
            content={this.props.content}
            showNoData
            noDataMessage={this.props.content.spendingTableLoading}
            tableClassName="table"
          />
        </div>
      );
    } else {
      const tableDataSorted = _.sortBy(tableData, ['name']);
      const matchedPotsData = _.find(tableDataSorted, { name: 'Pots' });
      if (_.isUndefined(matchedPotsData)) {
        const amount = 0;
        potData = (
          <div className="transaction-mobile-row">
            <article className="pots">
              <section>
                <span className={potColor} />
                <h6>Pots</h6>
              </section>
              <section>
                <h5>{NumberUtils.appendCurrency('{}', amount)}</h5>
              </section>
              <section>
                <OverlayPopup
                  overlayId="pots_key"
                  overlayMessage={this.props.content.spendingPotTooltipMessage}
                  placement="bottom"
                >
                  <span className="icon icon-information" />
                </OverlayPopup>
              </section>
            </article>
          </div>
        );
      } else {
        const indexOfPotData = tableDataSorted.indexOf(matchedPotsData);
        potDataRow = tableDataSorted.splice(indexOfPotData, 1);
        if (Number(potDataRow.length) > 0) {
          potData = potDataRow.map((item, index) => {
            const amount = NumberUtils.appendCurrency('{}', item.target_amount);
            differencePot =
              item.earnings.period.net_income.value - item.target_amount;
            if (differencePot < 0) {
              potColor = 'potcolor red';
            }
            return (
              <div
                className="transaction-mobile-row"
                key={`potDataRow_potData_${index}`}
              >
                <article className="pots">
                  <section>
                    <span className={potColor} />
                    <h6>{item.name}</h6>
                  </section>
                  <section>
                    <h5>{amount}</h5>
                  </section>
                  <section>
                    <OverlayPopup
                      overlayId="pots_key"
                      overlayMessage={
                        this.props.content.spendingPotTooltipMessage
                      }
                      placement="bottom"
                    >
                      <span className="icon icon-information" />
                    </OverlayPopup>
                  </section>
                </article>
              </div>
            );
          });
        }
      }

      const tableDataSortedFinal = _.sortedUniq(tableDataSorted);
      transactionScreenMobileRows = tableDataSortedFinal.map((item, index) => {
        return (
          <CreateBudgetTableRowTemplateMobile
            rowData={item}
            content={this.props.content}
            customClick={this.props.customClick}
            key={`transactionScreenMobileRows_CreateBudgetTableRowTemplate_Mobile_${index}`}
          />
        );
      });

      // transactionDataGridMobileScreen = (<div>{transactionScreenMobileRows}</div>);
    }
    return BrowserUtils.isMobileView() ? (
      <div className="list-view">
        {potData}
        <div className="create-budget-rowlist">
          {transactionScreenMobileRows}
        </div>
      </div>
    ) : (
      <div>{transactionDataGridDesktopScreen}</div>
    );
  }
}

SpendingsCreateBudgetDataGrid.propTypes = {
  content: PropTypes.object,
  customClick: PropTypes.func,
  tableData: PropTypes.array,
  sortTableData: PropTypes.func,
};

export { SpendingsCreateBudgetDataGrid };
